const { Serializer } = require("jsonapi-serializer");

module.exports = {
  removeInvestorSerializer: (meta = {}) =>
    new Serializer("store", {
      meta,
      pluralizeType: false,
      keyForAttribute: "snake_case",
      attributes: [
        "investment_id",
        "justification",
        "user_email",
        "user_ip"
      ]
    })
};
